/**
 * Договоры пользователя в районе — держатели договора по годам и основание
 * каждой смены. Раскрывается по клику на пользователя в списке района.
 */
import { useQuery } from '@tanstack/react-query'
import { cabinetApi } from '../api'
import { formatDay, formatNumber } from '../i18n/format'
import { useLang, useT } from '../i18n'
import { holderBasis, isGap } from './contractBasis'

export function ContractHistory({ inn, year, species, zone }: {
  inn: string; year: number; species: number | null; zone: number | null
}) {
  const t = useT()
  const { lang } = useLang()
  const q = useQuery({
    queryKey: ['quota-contracts', inn, year, species, zone],
    queryFn: () => cabinetApi.quotaHolderContracts({ inn, year, species, zone }),
  })
  if (q.isError) return <p className="py-1 text-[11px] text-mist">{t('quotas.hist.error')}</p>
  if (!q.data) return <p className="py-1 text-[11px] text-mist">…</p>
  if (!q.data.contracts.length) return <p className="py-1 text-[11px] text-mist">{t('quotas.hist.empty')}</p>
  return (
    <div className="mt-1 space-y-2">
      {q.data.contracts.map(c => (
        <div key={`${c.no}/${c.date}`} className="rounded border border-hull px-2 py-1">
          <div className="text-[11px] font-semibold text-foam">
            {t('quotas.hist.contract', { no: c.no, date: formatDay(lang, c.date) })}
          </div>
          {c.years.map(y => (
            <div key={y.year} className="mt-1">
              <div className="tnum text-[11px] text-mist">{y.year}</div>
              <ol className="space-y-0.5">
                {y.holders.map((h, i) => (
                  <li key={i} className="text-[11px] leading-snug">
                    <span className={isGap(h) ? 'italic text-mist' : 'text-foam'}>
                      {isGap(h) ? t('quotas.hist.noRow') : h.name}
                    </span>
                    <span className="tnum whitespace-nowrap text-mist">
                      {' · '}{h.to ? `${formatDay(lang, h.from)} – ${formatDay(lang, h.to)}`
                        : t('quotas.hist.since', { date: formatDay(lang, h.from) })}
                      {h.tons != null ? ` · ${formatNumber(lang, h.tons, 3)} ${t('quotas.t')}` : ''}
                    </span>
                    {holderBasis(h).length > 0 && (
                      <div className="text-mist">
                        {holderBasis(h).map(m => t(m.key, {
                          ...m.vars,
                          ...(m.vars && 'date' in m.vars ? { date: formatDay(lang, String(m.vars.date)) } : {}),
                        })).join('; ')}
                      </div>
                    )}
                  </li>
                ))}
              </ol>
            </div>
          ))}
        </div>
      ))}
    </div>
  )
}
